import { render, staticRenderFns } from "./Cash.vue?vue&type=template&id=4b4c0a6c&"
import script from "./Cash.vue?vue&type=script&lang=js&"
export * from "./Cash.vue?vue&type=script&lang=js&"
import style0 from "./Cash.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports